import styles from './default-render-cell.module.scss'

export const defaultRenderCell = <
  CellData extends { columnKey: string; value?: string | Array<string> | null },
>(
  cellData?: CellData,
) => {
  if (!cellData) {
    return <span>{'Поле не задано'}</span>
  }

  const { value } = cellData

  if ('value' in cellData) {
    return <span className={styles.root}>{value === null ? '—' : value}</span>
  }

  return <span>{'—'}</span>
}
